/**
 * One dial for how fast the loading hand-off and the shipwreck play: the wordmark's flight, night
 * falling, the ship being drawn and running aground, and every idle loop after it.
 *
 * The choreography (logo_choreography FLIGHT_*, shipwreck_geometry SCENE) is written in its own
 * milliseconds; real time is that divided by the pace. 0.5 means everything takes twice as long as
 * written -- the speed the user picked from the prototype. The HTML side of the hand-off (the wheel
 * and caption fading, in index.html) is timed to match by hand; change both together.
 */
export const INTRO_PACE = 0.5

/** Choreography time for a real elapsed time. */
export const choreoMs = (realMs: number): number => realMs * INTRO_PACE

/** Real time for a point in the choreography. */
export const realMs = (choreo: number): number => choreo / INTRO_PACE
